import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import {
  Navbar,
  Collapse,
  Nav,
  NavItem,
  NavbarBrand,
  UncontrolledDropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Button,
} from "reactstrap";
import user1 from "../assets/images/users/user4.jpg";
import { useAuth } from "../Context/AuthContext";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);

  let location = useLocation();
  const { logout } = useAuth()
  const user = JSON.parse(localStorage.getItem('user') || '{}')

  const toggle = () => setDropdownOpen((prevState) => !prevState);
  const Handletoggle = () => {
    setIsOpen(!isOpen);
  };

  return user ?
    <Navbar color="primary" dark expand="md" className="fix-header">
      <div className="hstack gap-2">
        <Button
          color="primary"
          size="sm"
          className="d-sm-block d-md-none"
          onClick={Handletoggle}
        >
          {isOpen ? (
            <i className="bi bi-x"></i>
          ) : (
            <i className="bi bi-list"></i>
          )}
        </Button>
      </div>

      {/* <NavbarBrand href="/">Zinc Technology</NavbarBrand> */}

      <Collapse navbar isOpen={isOpen}>
        {user?.role === "admin" ? <Nav className="me-auto" navbar>
          <NavItem>
            <NavLink to="/admin" className={`${location.pathname === "/admin" ? "active" : ""} nav-link`}>
              <i className="bi bi-speedometer2"></i>
              Dashboard
            </NavLink>
          </NavItem>
          <UncontrolledDropdown inNavbar nav>
            <DropdownToggle caret nav className={`${["/admin/users", "/admin/pending-users", "/admin/cancel-users", "/admin/package"].includes(location.pathname) ? "sub-menu-active" : ""}`}>
              <i className="bi bi-person-add"></i>
              User Registration
            </DropdownToggle>
            <DropdownMenu end>
              <DropdownItem className="p-0">
                <NavLink to="/admin/users" className={`${location.pathname === "/admin/users" ? "sub-menu-active" : ""} nav-link text-dark`}>
                  <i className="bi bi-person-add"></i>
                  Registration
                </NavLink>
              </DropdownItem>
              <DropdownItem className="p-0">
                <NavLink to="/admin/pending-users" className={`${location.pathname === "/admin/pending-users" ? "sub-menu-active" : ""} nav-link text-dark`}>
                  <i className="bi bi-clock-history"></i>
                  Pending
                </NavLink>
              </DropdownItem>
              {/* <DropdownItem className="p-0">
                <NavLink to="cancel-users" className={`${location.pathname === "cancel-users" ? "sub-menu-active" : ""} nav-link text-dark`}>
                  <i className="bi bi-x-circle"></i>
                  Cancel
                </NavLink>
              </DropdownItem> */}
              <DropdownItem className="p-0">
                <NavLink to="/admin/package" className={`${location.pathname === "/admin/package" ? "sub-menu-active" : ""} nav-link text-dark`}>
                  <i className="bi bi-file-earmark"></i>
                  Package
                </NavLink>
              </DropdownItem>
            </DropdownMenu>
          </UncontrolledDropdown>
          {/* <NavItem>
            <NavLink to="/admin/block-users" className={`${location.pathname === "/admin/block-users" ? "sub-menu-active" : ""} nav-link `}>
              <i className="nav-icon bi bi-person-fill-dash"></i>
              Deactivate User
            </NavLink>
          </NavItem> */}
          <NavItem>
            <NavLink to="/admin/qc-reports" className={`${location.pathname === "/admin/qc-reports" ? "sub-menu-active" : ""} nav-link `}>
              <i className="bi bi-file-earmark-text"></i>
              QC Reports
            </NavLink>
          </NavItem>
          {/* <NavItem>
            <NavLink to="/admin/recovery" className={`${location.pathname === "/admin/recovery" ? "sub-menu-active" : ""} nav-link `}>
              <i className="bi bi-arrow-clockwise"></i>
              Recovery
            </NavLink>
          </NavItem> */}
          <NavItem>
            <NavLink to="/admin/employee" className={`${location.pathname === "/admin/employee" ? "sub-menu-active" : ""} nav-link `}>
              <i className="bi bi-people"></i>
              Employee
            </NavLink>
          </NavItem>
          {/* <NavItem>
            <NavLink to="/admin/system-users" className={`${location.pathname === "/admin/system-users" ? "sub-menu-active" : ""} nav-link `}>
              <i className="bi bi-people"></i>
              System User
            </NavLink>
          </NavItem> */}
        </Nav> : user?.role === "user" ?
          <Nav className="me-auto" navbar>
            <NavItem>
              <NavLink to="/user" className={`${location.pathname === "/user" ? "active" : ""} nav-link`}>
                <i className="bi bi-speedometer2"></i>
                Dashboard
              </NavLink>
            </NavItem>
            <UncontrolledDropdown inNavbar nav>
              <DropdownToggle caret nav className={`${["/user/work-load", "/user/all-forms", "/user/submited-forms"].includes(location.pathname) ? "sub-menu-active" : ""}`}>
                <i className="bi bi-person-add"></i>
                Work Load
              </DropdownToggle>
              <DropdownMenu end>
                <DropdownItem className="p-0">
                  <NavLink to="/user/work-load" className={`${location.pathname === "/user/work-load" ? "sub-menu-active" : ""} nav-link text-dark`}>
                    <i className="bi bi-person-add"></i>
                    Current Work Load
                  </NavLink>
                </DropdownItem>
                {/* <DropdownItem className="p-0">
                  <NavLink to="/user/all-forms" className={`${location.pathname === "/user/all-forms" ? "sub-menu-active" : ""} nav-link text-dark`}>
                    <i className="bi bi-clock-history"></i>
                    All Forms
                  </NavLink>
                </DropdownItem> */}
                {/* <DropdownItem className="p-0">
                  <NavLink to="/user/saved-forms" className={`${location.pathname === "/user/saved-forms" ? "sub-menu-active" : ""} nav-link text-dark`}>
                    <i className="bi bi-x-circle"></i>
                    Saved Forms
                  </NavLink>
                </DropdownItem> */}
                <DropdownItem className="p-0">
                  <NavLink to="/user/submited-forms" className={`${location.pathname === "/user/submited-forms" ? "sub-menu-active" : ""} nav-link text-dark`}>
                    <i className="bi bi-file-earmark"></i>
                    Submited Forms
                  </NavLink>
                </DropdownItem>
              </DropdownMenu>
            </UncontrolledDropdown>
            <NavItem>
              <NavLink to="/user/report" className={`${location.pathname === "/user/report" ? "sub-menu-active" : ""} nav-link `}>
                <i className="bi bi-people"></i>
                Report
              </NavLink>
            </NavItem>
          </Nav>
          : ""}

        {user?.role && <Dropdown isOpen={dropdownOpen} toggle={toggle}>
          <DropdownToggle color="transparent">
            <img
              src={user1}
              alt="profile"
              className="rounded-circle"
              width="30"
            ></img>
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem header>Hello {user && user?.appName == "[DEFAULT]" ? "There" : user?.appName},</DropdownItem>
            <DropdownItem disabled>My Account</DropdownItem>
            {user?.role === "admin" ? <NavLink to='/admin/change-password' className={'nav-link'}><DropdownItem>Change Password</DropdownItem></NavLink> : <></>}
            <DropdownItem onClick={() => logout()}>Logout</DropdownItem>
          </DropdownMenu>
        </Dropdown>}
      </Collapse>
    </Navbar> : <></>
};

export default Header;
